export default __webpack_public_path__ + "static/media/scania_trucks.284b85a9.png";